import React from 'react'
import { ValueLocked } from 'src/components/framework/icons/value-locked'
import { SectionHeader } from 'src/components/framework/ui/section-header'
import { RatioGraph } from 'src/components/page/ratios/ratio-graph'
import { RatioLink } from 'src/components/page/ratios/ratios'

export const RecentHistory: React.FC = () => {
  return (
    <>
      <SectionHeader>Recent History</SectionHeader>
      <div className={'stk-table-group'}>
        <table>
          <thead>
            <tr>
              <th colSpan={2}>Latest interim period vs. prior period</th>
              <th style={{ width: '1%' }}>Industry</th>
              <th style={{ width: '1%' }}>Market</th>
            </tr>
          </thead>
          <tbody>
            {LATEST_VS_PRIOR_RATIOS.map((ratio, index) => (
              <tr key={index}>
                <td>
                  <RatioLink id={ratio.id}>{ratio.name}</RatioLink>
                </td>
                <td style={{ width: '1%' }}>
                  <ValueLocked />
                </td>
                <td>
                  <RatioGraph percentile={0} locked={true} />
                </td>
                <td>
                  <RatioGraph percentile={0} locked={true} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <table>
          <thead>
            <tr>
              <th colSpan={2}>3yr Compound Annual Growth Rate</th>
              <th style={{ width: '1%' }}>Industry</th>
              <th style={{ width: '1%' }}>Market</th>
            </tr>
          </thead>
          <tbody>
            {GROWTH_RATE_RATIOS.map((ratio, index) => (
              <tr key={index}>
                <td>
                  <RatioLink id={ratio.id}>{ratio.name}</RatioLink>
                </td>
                <td style={{ width: '1%' }}>
                  <ValueLocked />
                </td>
                <td>
                  <RatioGraph percentile={0} locked={true} />
                </td>
                <td>
                  <RatioGraph percentile={0} locked={true} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  )
}

interface Ratio {
  name: string
  id: string
}

const LATEST_VS_PRIOR_RATIOS: ReadonlyArray<Ratio> = [
  {
    name: 'Sales Growth',
    id: 'sales-growth-last-interim-period-vs-prior-year-period-1000',
  },
  {
    name: 'EPS Growth',
    id: 'earnings-per-share-growth-last-interim-period-versus-prior-year-period-586',
  },
]

const GROWTH_RATE_RATIOS: ReadonlyArray<Ratio> = [
  { name: 'Sales CAGR', id: 'sales-3-year-compound-annual-growth-rate-849' },
  { name: 'EPS CAGR', id: 'normalised-earnings-per-share-3-year-cagr-237' },
  {
    name: 'DPS CAGR',
    id: 'dividend-per-share-3-year-compound-annual-growth-rate-289',
  },
]
